namespace $ {

	/** Keeps only the canonical page Land alive, not its payload or Dataset. */
	export class $shm_hitalama_map_widget_entity_table2_dataset_page_land extends $mol_object {

		link() { return $giper_baza_link.hole }

		private observer = new $mol_wire_pub_sub

		read() {
			const previous = this.observer.track_on()
			try {
				return this.$.$giper_baza_glob.Land( this.link() )
			} finally {
				this.observer.track_cut()
				this.observer.track_off( previous )
			}
		}

		destructor() {
			this.observer.destructor()
			super.destructor()
		}

	}

}
